import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import { buildEnrichedOptionValueDetailsMap, convertProductOptionsToUsableFormat } from 'components/consumer/PDP/helpers/pdpOptionUtils';
import useAllOptions from 'data-hooks/useAllOptions';
import usePDPQueryOptionsForProduct from './usePDPQueryOptionsForProduct';
const usePDPGetOptionsForProduct = (t0, t1) => {
  const $ = _c(18);
  let t2;
  if ($[0] !== t0) {
    t2 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    slug,
    initialProductOptions
  } = t2;
  let t3;
  if ($[2] !== t1) {
    t3 = t1 === undefined ? {} : t1;
    $[2] = t1;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const {
    skip: t4
  } = t3;
  const skip = t4 === undefined ? false : t4;
  const isEnriched = initialProductOptions?.optionsEnriched === true;
  const {
    isLoading: allOptionValuesLoading,
    allOptionsValues,
    error: allOptionValuesError
  } = useAllOptions(isEnriched);
  const isAllOptionsLoading = !isEnriched && allOptionValuesLoading && !allOptionsValues;
  let t5;
  if ($[4] !== initialProductOptions || $[5] !== slug) {
    t5 = {
      slug,
      initialProductOptions
    };
    $[4] = initialProductOptions;
    $[5] = slug;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== skip) {
    t6 = {
      skip
    };
    $[7] = skip;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const {
    loading: productOptionsLoading,
    error: productOptionsError,
    data: productOptionsData
  } = usePDPQueryOptionsForProduct(t5, t6);
  let t7;
  bb0: {
    if (isEnriched && productOptionsData?.productOptions) {
      let t8;
      if ($[9] !== productOptionsData) {
        const enrichedValueMap = buildEnrichedOptionValueDetailsMap(productOptionsData);
        t8 = convertProductOptionsToUsableFormat(productOptionsData, enrichedValueMap);
        $[9] = productOptionsData;
        $[10] = t8;
      } else {
        t8 = $[10];
      }
      t7 = t8;
      break bb0;
    }
    if (!productOptionsData?.productOptions || !allOptionsValues) {
      t7 = null;
      break bb0;
    }
    let t8;
    if ($[11] !== allOptionsValues || $[12] !== productOptionsData) {
      t8 = convertProductOptionsToUsableFormat(productOptionsData, allOptionsValues);
      $[11] = allOptionsValues;
      $[12] = productOptionsData;
      $[13] = t8;
    } else {
      t8 = $[13];
    }
    t7 = t8;
  }
  const productOptions = t7;
  const t8 = productOptionsLoading || isAllOptionsLoading;
  const t9 = productOptionsError || allOptionValuesError;
  let t10;
  if ($[14] !== productOptions || $[15] !== t8 || $[16] !== t9) {
    t10 = {
      data: productOptions,
      loading: t8,
      error: t9
    };
    $[14] = productOptions;
    $[15] = t8;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  return t10;
};
export default usePDPGetOptionsForProduct;